import styled from "styled-components";

export const Card = styled.div`
  border: ${({ theme }) => theme.borders.orangeFrame};
  border-color: ${({ theme }) => theme.colors.grey350};
  border-radius: 10px;
  padding: 20px;
`;

export const CardTitle = styled.h2`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primaryBlack};
`;
